import {client as http, axiosInstance} from "@/http_client";
import async from "async";

export default {
    state: {
        registrations: null
    },
    getters: {
        registrations: state => state.registrations
    },
    mutations: {},
    actions: {
        getRegistrations({state}) {
            return new Promise((resolve, reject) => {
                let registrations;

                async.series([
                    (cb) => {
                        http.get('app/registrations/', {force: true}).then(response => {
                            registrations = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                ], (err) => {
                    if (err) {
                        console.log('err', err);
                        reject(err.response);
                        return;
                    }
                    state.registrations = registrations;
                    resolve(registrations);
                });
            });
        },
    }
};
